<template>
  <div class="saved-filters-widget">
    <div
      v-if="savedFilters.items.length !== 0"
      class="saved-filters-widget__filters"
    >
      <SavedFiltersList
        :savedFilters="savedFilters.items"
        @click="$emit('click', $event)"
        @remove="savedFilters.remove"
      />
    </div>
    <div v-else class="saved-filters-widget__empty">
      Сохраните ваш выбор, чтобы каждый раз не&nbsp;настраивать фильтр.
      Установите нужные параметры поиска и&nbsp;нажмите на&nbsp;кнопку &laquo;Сохранить фильтр&raquo; внизу фильтров.
    </div>
  </div>
</template>

<script>
  import SavedFiltersList from "src/components/filters/SavedFiltersList/SavedFiltersList.vue";

  export default {
    name: 'SavedFiltersWidget',
    components: { SavedFiltersList },
    inject: ['savedFilters']
  }
</script>